import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM9 7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4h-1v5h-1.333L12 12.087 11.333 16H10v-5H9V7Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.79 15c-.703.433-.79.758-.79.86 0 .066.027.213.248.441.227.233.605.492 1.155.74.903.406 2.145.726 3.597.883v-.986l3.25 2.03L10 21v-1.066c-1.698-.164-3.232-.536-4.418-1.07-.69-.31-1.308-.696-1.768-1.17C3.35 17.218 3 16.597 3 15.86c0-1.16.842-2.009 1.74-2.563.94-.579 2.205-1.01 3.623-1.28l.372 1.966c-1.273.241-2.282.609-2.945 1.017Zm12.42 0c-.663-.408-1.672-.776-2.945-1.018l.372-1.964c1.418.268 2.683.7 3.622 1.28C20.158 13.85 21 14.7 21 15.86s-.844 2.01-1.745 2.565c-.94.579-2.209 1.011-3.629 1.28l-.371-1.966c1.276-.241 2.288-.609 2.952-1.018.706-.434.793-.76.793-.861 0-.102-.087-.427-.79-.86Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionMyLocation24 = createIcon(IconComponent);